import angular from 'angular';
import moment from 'moment';
import { MeurhSolicitacoesalteracoesenderecosService } from '../solicitacoesalteracoesenderecos.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { ISolicitacaoAlteracaoEndereco } from '../models/solicitacaoalteracaoendereco.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

type IMeurhSolicitacoesalteracoesenderecosIndexFilter = {
    empresa?: string;
    estabelecimento?: string;
    situacao?: string;
    trabalhador_tipo?: string;
    lotacao?: {
        lotacao: string;
    } | null;
};

export class MeurhSolicitacoesalteracoesenderecosIndexController implements angular.IController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        'NewToaster',
        'MeurhSolicitacoesalteracoesenderecosService',
        'ListagemService',
        '$location'
    ];

    public busy: boolean = false;
    public filters: IMeurhSolicitacoesalteracoesenderecosIndexFilter = {};
    public tipo: string;
    public tipoInicial: string;
    public dataInicial: string | null = null;
    public dataFinal: string | null = null;
    public dataAtual = moment();
    public empresas: Array<Empresa>;
    public estabelecimentos: Array<Estabelecimento>;
    public listagemPermissao: Array<string> = ['visualizar_alteracaodadoscadastrais'];
    public permissaoGrupoEmpresarial = false;
    public entities: Array<Partial<ISolicitacaoAlteracaoEndereco>>;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            temPermissao: (arg: string) => boolean,
            session: any,
            nsjGlobals: any
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public NewToaster: { pop: Function },
        public entityService: MeurhSolicitacoesalteracoesenderecosService,
        public ListagemService: ListagemService,
        public $location: angular.ILocationService,
    ) {
        if (!$rootScope.temPermissao('visualizar_alteracaodadoscadastrais')) {
            $state.go('dp', $stateParams);
        }

        entityService.filter = $stateParams['q'] ? $stateParams['q'] : '';
        entityService.filters = {};
        entityService.constructors = {};

        this.tipo = $stateParams['tipo'];
        this.tipoInicial = $stateParams['tipo'];

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.filters = {
            ...this.filters,
            trabalhador_tipo: this.tipo === '-1' ? '' : this.tipo,
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
        };

        this.montaListagemVisibilidade();

        this.entities = this.filterReload();

        $scope.$on('meurh_solicitacoesalteracoesenderecos_deleted', () => {
            this.entities = this.entityService.reload();
        });

        $scope.$on('meurh_solicitacoesalteracoesenderecos_submitted', (event: angular.IAngularEvent, args: any) => {
            if (!args.autosave && args.entity.situacao !== -1) {
                this.entities = this.entityService.reload();
            }
        });

        $scope.$on('meurh_solicitacoesalteracoesenderecos_cancelada', (event: angular.IAngularEvent, args: any) => {
            this.entities = this.entityService.reload();
        });

        $scope.$on('$destroy', () => {
            if (entityService.loading_deferred) {
                entityService.loading_deferred.resolve();
            }
        });

    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        delete this.filters.lotacao;
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    constructorEmpresaEstabelecimento() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    search(): Array<Partial<ISolicitacaoAlteracaoEndereco>> {
        if (this.entityService.filter !== '') {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.entityService.filter }));
        } else {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters));
        }

        const filter = {
            search: this.entityService.filter,
            filters: angular.copy(this.entityService.filters)
        };
        return this.entityService.search(filter);
    }

    loadMore(): void {
        this.entityService.loadMore();
    }

    finished(): boolean {
        return this.entityService.loadParams.finished;
    }

    isBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    filterReload() {
        const constructors: any = { ...this.filters };

        if (!this.valorExiste(constructors.situacao)) {
            delete constructors.situacao;
        }

        if (!this.valorExiste(constructors.trabalhador_tipo)) {
            delete constructors.trabalhador_tipo;
        }

        if (!this.valorExiste(constructors.lotacao)) {
            delete constructors.lotacao;
        } else {
            constructors.lotacao = constructors.lotacao.lotacao;
        }

        if (
            this.dataInicial !== null && this.dataFinal !== null &&
            this.dataInicial !== '' && this.dataFinal !== '' &&
            this.dataInicial > this.dataFinal
        ) {
            this.NewToaster.pop({
                type: 'error',
                title: 'A data inicial não pode ser posterior a data final'
            });
            return [];
        }

        const created_at: { condition: string, value: string }[] = [];

        if (
            this.dataInicial === undefined ||
            (this.dataInicial !== null && this.dataInicial.length === 0)
        ) {
            this.dataInicial = null;
            constructors.datainicial = null;
        }

        if (this.dataInicial !== null) {
            created_at.push(
                {
                condition: 'gte',
                value: this.dataInicial + ' 00:00:00'
                }
            );
            delete constructors.datainicial;
        }

        if (
            this.dataFinal === undefined ||
            (this.dataFinal !== null && this.dataFinal.length === 0)
        ) {
            this.dataFinal = null;
            constructors.datafinal = null;
        }

        if (this.dataFinal !== null) {
            created_at.push(
                {
                condition: 'lte',
                value: this.dataFinal + ' 23:59:59'
                }
            );
            delete constructors.datafinal;
        }

        constructors.created_at = created_at;
        this.entityService.constructors = constructors;
        return this.entityService.reload();
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
